{
  "common": {
    "save": "Save",
    "saving": "Saving...",
    "cancel": "Cancel"
  },
  "header": {
    "title": "Members area gamification",
    "subtitle": "Configure your members area gamification",
    "tabs": {
      "points": "Points",
      "levels": "Levels",
      "tasks": "Tasks"
    }
  },
  "toggle": {
    "label": "Enable gamification",
    "enabled": "Gamification enabled!",
    "disabled": "Gamification disabled!",
    "error": "Error updating setting"
  },
  "points": {
    "title": "Configure the default points for each gamification trigger",
    "unit": "Pts.",
    "saveSuccess": "Settings saved successfully!",
    "saveError": "Error saving settings",
    "actions": {
      "lessonCompleted": "Lesson completed",
      "courseStarted": "Course started",
      "course25Percent": "Course 25% completed",
      "course50Percent": "Course 50% completed",
      "course75Percent": "Course 75% completed",
      "courseCompleted": "Course completed",
      "dailyLogin": "Login",
      "lessonFavorited": "Lesson favorited",
      "commentPosted": "Message posted",
      "certificateEarned": "Certificate issued",
      "challengeActivityCompleted": "Challenge activity completed",
      "challengeMissionCompleted": "Challenge mission completed",
      "challengeCompleted": "Challenge completed",
      "communityPostCreated": "Mission: create post",
      "communityCommentCreated": "Mission: comment",
      "communityPostLiked": "Mission: like post"
    }
  },
  "levels": {
    "title": "Configure your gamification levels",
    "create": "Create level",
    "table": {
      "level": "Level",
      "points": "Points",
      "color": "Color",
      "reward": "Reward"
    },
    "rewardsConfigured_one": "{{count}} reward configured",
    "rewardsConfigured_zero": "{{count}} rewards configured",
    "rewardsConfigured_other": "{{count}} rewards configured",
    "edit": "Edit",
    "delete": "Delete",
    "deleteConfirm": {
      "title": "Delete level",
      "description": "Are you sure you want to delete this level?",
      "confirm": "Delete"
    },
    "deleteSuccess": "Level deleted successfully!",
    "deleteError": "Error deleting level",
    "empty": {
      "title": "No levels configured",
      "description": "Start by creating your first level",
      "create": "Create Level"
    }
  },
  "tasks": {
    "title": "Tasks coming soon",
    "description": "The tasks feature will be available in a future update."
  },
  "explanation": {
    "button": "Explanation for students",
    "dialogTitle": "Explanation for students",
    "dialogDescription": "This text will be shown to students on the ranking page, explaining how gamification works.",
    "placeholder": "Write the explanation of how gamification works...",
    "saveSuccess": "Explanation text saved!",
    "saveError": "Error saving text",
    "defaultText": "Welcome to our platform's gamification!\n\nHere in our community, we've built a points system to recognize and reward member engagement. Through this gamification, you'll have the chance to earn points and badges, level up and unlock amazing rewards.\n\nBelow is the points table we use:\n\n• Lesson completed: When you complete a lesson, you'll receive 10 points.\n• Course started: Starting a course also earns you 50 points.\n• Reaching 25% of a course: When you reach 25% progress in a course, you'll be awarded 20 points.\n• Reaching 50% of a course: When you reach the halfway point of a course, you'll earn 30 additional points.\n• Reaching 75% of a course: When you reach 75% of a course, you'll be rewarded with 50 points.\n• Course completed: Completing an entire course earns you 100 points.\n• Certificate issued: When you earn a certificate, you'll receive a 100-point bonus.\n• Favoriting a lesson: Favoriting a lesson gives you 5 points.\n• Daily login: Just logging in to the platform earns you 5 points.\n• Message posted: Every time you post a message in the forum or community, you'll receive 5 points.\n\nWe're excited to introduce our six gamification levels:\n\n→ Level 1: To reach the first level, you need to earn 1 point.\n→ Level 2: To reach the second level, you need to earn 500 points.\n→ Level 3: To reach the third level, you need to earn 1,000 points.\n→ Level 4: To reach the fourth level, you need to earn 2,000 points.\n→ Level 5: To reach the fifth level, you need to earn 3,000 points.\n→ Level 6: To reach the sixth and final level, you need to earn 4,000 points.\n\nKeep an eye on your achievements and progress right on your profile, because our community values your engagement and wants to encourage you to explore everything we have to offer. Gamification is a fun and motivating way to get involved on the platform while you learn, share knowledge and connect with other passionate members.\n\nWe can't wait to see you scoring high, moving up the levels and reaching your goals.\n\nGood luck and have fun in our gamified community!"
  }
}
